import * as React from 'react'
import { cn } from '@/lib/utils'

export interface GradientTextProps extends React.HTMLAttributes<HTMLSpanElement> {
  as?: 'span' | 'em' | 'strong'
}

export const GradientText = React.forwardRef<HTMLSpanElement, GradientTextProps>(
  ({ className, as = 'span', ...props }, ref) => {
    const Comp = as as 'span'
    return (
      <Comp
        ref={ref}
        className={cn('grad-text', className)}
        {...props}
      />
    )
  },
)
GradientText.displayName = 'GradientText'
